import type React from 'react';

import * as pages from '../pages';

export interface RouteInfo {
  title: string;
  path: string;
  Component: React.ComponentType;
}

export const routes = Object.values(pages) satisfies RouteInfo[];
